import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import InputGroup from "../../components/FormComponent/InputGroup";
import Circle1 from "../../assets/images/Circle1.svg";
import Circle2 from "../../assets/images/Circle2.svg";
import logo from "../../assets/images/admin.svg";
import useValidator from "../../hooks/useValidator";
import { ToastContainer } from "react-toastify";
import Button from "../../components/Button/Button";
import { Icon } from "@iconify/react";
import styles from "./signup/signUp.module.css";

// --| Context files
import { useUserDispatch, handleLogin } from "../../context/UserContext";

const Login = () => {
  const userDispatch = useUserDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [loginValidator, showValidationMessage] = useValidator();
  const navigate = useNavigate();

  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    platform: "web"
  });

  const { email, password } = loginForm;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginForm({ ...loginForm, [name]: value });
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div className={styles.logincontainer}>
      <div className={styles.forsignup}>
        <div className={styles.container}>
          <div className={`${styles.SecondCircle}`}>
            <img src={Circle2} alt="" />
          </div>
          <div className={`${styles.FirstCircle}`}>
            <img src={Circle1} alt="" />
          </div>
          <div className={`${styles.Random}`}>
            <img src={logo} alt="logo" className="auth-logo" />
          </div>
          <div className={`${styles.maincontainer} auth-form`}>
            <React.Fragment>
              <div className="auth-heading">Login</div>
              <div className="input-group-styling">
                <InputGroup
                  label="Email Address"
                  inputValue={email}
                  onChange={handleChange}
                  margin="normal"
                  inputName="email"
                  // placeHolder="Email Adress"
                  inputType="email"
                />
              </div>
              <div className="input-padding">
                <InputGroup
                  label="Password"
                  inputValue={password}
                  onChange={handleChange}
                  inputName="password"
                  inputType={passwordType}
                />
                <div className="password-eye">
                  {passwordType === "password" ? (
                    <Icon icon="fluent:eye-16-regular" color="black" onClick={togglePassword} />
                  ) : (
                    <Icon icon="iconamoon:eye-off-light" color="black" onClick={togglePassword} />
                  )}
                </div>
                {loginValidator.message("password", password, "required")}
              </div>
              <div style={{ marginTop: "1rem" }} className={`${styles.Footer1}auth-form-buttons `}>
                <Button buttonName="Login" variant="primary" buttonSize="full"
                  color="btndefault"
                  type="button"
                  isLoading={isLoading}
                  onClick={() => handleLogin(
                    userDispatch,
                    loginForm,
                    navigate,
                    setIsLoading,
                    showValidationMessage,
                    loginValidator
                  )
                  }
                />
                <Link to="/admin-forgot-password"
                  className="auth-forget-button input-padding"
                >
                Forgot Password ?
                </Link>
              </div>
            </React.Fragment>
            <div className={`${styles.Footer2} auth-account-button input-group-styling`}>
            Don't have an account ?
              <Link to="/auth/signup" className="">Create an account</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={10000} />

    </div>
  );
};
export default Login;
